<template>
  <div class="img-box border d-flex flex-column justify-content-between">
    <b-avatar
      style="width: 100%; min-height: 60px"
      v-if="file.type == 'application/pdf'"
      src="https://avatars.mds.yandex.net/i?id=92091a126a7e7aed961e2dbe7521afa6-4819109-images-thumbs&n=13"
    />
    <b-avatar
      square
      style="width: 100%; min-height: 60px"
      v-else
      :src="file.file"
      icon="file-earmark"
    />

    <div>
      <div class="d-flex justify-content-between">
        <span
          style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap"
          >{{ file.title }}</span
        >
        <div>
          <feather-icon
            icon="XIcon"
            class="ml-50 trash-icon"
            size="18"
            v-if="upload && !loading"
            @click.stop="$emit('removeItem', index)"
          />
          <feather-icon
            icon="Trash2Icon"
            class="ml-50 trash-icon"
            size="18"
            v-if="!upload"
            @click.stop="$emit('deleteFile', file.id, index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCol, BProgress, BAvatar } from "bootstrap-vue";

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    file: {
      type: Object,
      required: true,
    },
    upload: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BCol,
    BProgress,
    BAvatar,
  },
};
</script>

<style scoped>
.trash-icon {
  color: red;
  cursor: pointer;
}
</style>
